import {useQuery} from '@tanstack/react-query';

import {apiClient} from '../../../../../utils/api-client';

export interface ImportedOntology {
    name: string;
    lastImported: number;
    totalElements: number;
}

export const useOntologyQuery = (props: {
    documentId?: number;
    accession: string;
    isExploreMode: boolean;
}) => {
    const path = props.isExploreMode
        ? `documents-revisions-service/api/ontologies?document-id=${props.documentId}`
        : `documents-revisions-service/api/ontologies?accession=${props.accession}`;

    return useQuery({
        queryKey: ['getOntology', props.accession, props.documentId],
        queryFn: async () =>
            apiClient.get<ImportedOntology>({
                path
            })
    });
};
